export const field = "w-full bg-[#0B0C10] border border-[#F5A524]/30 focus:border-[#F5A524] outline-none px-3 py-2.5 text-sm text-white";

export const Label = ({ children }) => <span className="block font-mono text-[11px] tracking-[0.25em] text-zinc-400 mb-2">{children}</span>;

export const FormActions = ({ busy, onCancel, label = "SAVE" }) => (
  <div className="flex gap-3 pt-2">
    <button data-testid="form-submit-btn" disabled={busy} className="flex-1 clip-tab bg-[#F5A524] text-black font-mono font-bold tracking-[0.2em] py-3 hover:bg-white disabled:opacity-60 transition-colors">
      {busy ? "SAVING..." : label}
    </button>
    <button type="button" data-testid="form-cancel-btn" onClick={onCancel} className="px-6 border border-[#F5A524]/30 font-mono text-xs tracking-[0.2em] text-zinc-300 hover:border-[#F5A524]">CANCEL</button>
  </div>
);
